import type { SVGProps } from "react";
import { Clock, Mail, MapPin, Phone } from "lucide-react";

// @ts-ignore //Weird image issues...
import Logo from "../assets/Logo.png";

const quickLinks = [
  { title: "Home", href: "#home" },
  { title: "Services", href: "#services" },
  { title: "Why Us", href: "#why-us" },
  { title: "Our Work", href: "#work" },
  { title: "Reviews", href: "#reviews" },
  { title: "FAQ", href: "#faq" },
];

const serviceLinks = [
  "Socket & Switch Installation",
  "Electrical Wiring & Rewiring",
  "Light Fixture Installation & Repair",
  "EV Charger Installation",
  "Electrical Inspections",
  "Panel Repair & Upgrade",
  "Alarm & Security Installation",
  "24/7 Emergency Call-Outs",
];

const FacebookIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M22 12.06C22 6.51 17.52 2 12 2S2 6.51 2 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.51 1.49-3.9 3.77-3.9 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.91h-2.33V22c4.78-.76 8.44-4.92 8.44-9.94Z" />
  </svg>
);

const InstagramIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
  </svg>
);

export const Footer = () => {
  return (
    <footer id="contact" className="scroll-mt-20 border-t border-white/10 bg-neutral-950 text-neutral-300">
      <div className="mx-auto max-w-360 px-4 py-16 md:px-8">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="flex flex-col gap-4">
            <img
              src={Logo}
              alt="E.I.M Electrical Contractors"
              className="h-12 w-fit rounded bg-white p-1.5"
            />
            <p className="text-sm">
              Your local sparky for residential and commercial electrical
              work across Blackpool, Lytham St Annes, Poulton-le-Fylde,
              Fleetwood, Cleveleys and Preston.
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                aria-label="Facebook"
                className="flex size-9 items-center justify-center rounded-full border border-white/10 transition-colors hover:bg-primary hover:text-primary-foreground"
              >
                <FacebookIcon className="size-4" />
              </a>
              <a
                href="#"
                aria-label="Instagram"
                className="flex size-9 items-center justify-center rounded-full border border-white/10 transition-colors hover:bg-primary hover:text-primary-foreground"
              >
                <InstagramIcon className="size-4" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wider text-white uppercase">
              Quick Links
            </h3>
            <ul className="mt-4 flex flex-col gap-2 text-sm">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="transition-colors hover:text-primary">
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wider text-white uppercase">
              Services
            </h3>
            <ul className="mt-4 flex flex-col gap-2 text-sm">
              {serviceLinks.map((service) => (
                <li key={service}>
                  <a href="#services" className="transition-colors hover:text-primary">
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wider text-white uppercase">
              Get In Touch
            </h3>
            <ul className="mt-4 flex flex-col gap-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 size-4 shrink-0 text-primary" />
                <span>5 Thistle Cl, Blackpool, FY5 2UN</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-4 shrink-0 text-primary" />
                <a href="tel:07850458907" className="transition-colors hover:text-primary">
                  07850 458907
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-4 shrink-0 text-primary" />
                <a
                  href="mailto:info@eim-electrical.co.uk"
                  className="transition-colors hover:text-primary"
                >
                  info@eim-electrical.co.uk
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="mt-0.5 size-4 shrink-0 text-primary" />
                <div>
                  <p>Mon - Fri: 7:30am - 6:00pm</p>
                  <p>Saturday: 8:00am - 1:00pm</p>
                  <p>Sunday: Emergency call-outs only</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-neutral-500 sm:flex-row">
          <p>© {new Date().getFullYear()} E.I.M Electrical Contractors. All rights reserved.</p>
          <p>Fully Licensed & Insured Electrician · Blackpool, FY5 2UN</p>
        </div>
      </div>
    </footer>
  );
};
